var l = Object.defineProperty;
var u = (i, s, e) => s in i ? l(i, s, { enumerable: !0, configurable: !0, writable: !0, value: e }) : i[s] = e;
var n = (i, s, e) => u(i, typeof s != "symbol" ? s + "" : s, e);
var c = /* @__PURE__ */ ((i) => (i.STRING = "STRING", i.NUMBER = "NUMBER", i.DATE = "DATE", i.DATETIME = "DATETIME", i.UUID = "UUID", i))(c || {});
class h {
  constructor(s) {
    n(this, "views");
    n(this, "dimensions");
    this.dimensions = s.reduce(
      (e, t) => t.dimensions.reduce((o, r) => {
        var d;
        return {
          ...o,
          [r.code]: {
            ...r,
            asSimple: r["@type"] === "simple",
            viewCodes: [...((d = o[r.code]) == null ? void 0 : d.viewCodes) || [], t.code]
          }
        };
      }, e),
      {}
    ), this.views = s.reduce(
      (e, t) => ({
        ...e,
        [t.code]: {
          ...t,
          dimensions: t.dimensions.map((o) => this.dimensions[o.code])
        }
      }),
      {}
    );
  }
  listViews() {
    return Object.values(this.views).sort((s, e) => s.alias.localeCompare(e.alias));
  }
  getView(s) {
    return this.views[s];
  }
  listDimensions() {
    return Object.values(this.dimensions);
  }
  getDimension(s) {
    return this.dimensions[s];
  }
  checkDimensionInView(s, e) {
    var t;
    return ((t = typeof s == "string" ? this.dimensions[s] : s) == null ? void 0 : t.viewCodes.includes(typeof e == "string" ? e : e.code)) || !1;
  }
}
export {
  c as SemanticType,
  h as default
};
//# sourceMappingURL=MetaModel.js.map
